import React from "react";
import { StarIcon } from "lucide-react";
import { testimonials } from "../../data/content";
import { CtaButton } from "../CtaButton";
export function Testimonials() {
  return <section className="bg-paper py-16 sm:py-20" aria-labelledby="testimonials-title" data-id="element-254" data-mp="3mh2bjwf1lign">
      <div className="mx-auto max-w-5xl px-5" data-id="element-255" data-mp="3meze4rbk8n1w">
        <h2 id="testimonials-title" className="text-center font-display text-[30px] font-black leading-tight text-ink sm:text-[42px]" data-id="element-256" data-mp="3r8k9scpol4xx">
          What physical therapists are <em className="text-brand" data-id="element-257" data-mp="42jcdmkzqiia">saying</em>
        </h2>

        <div className="mt-10 grid gap-5 md:grid-cols-2" data-id="element-258" data-mp="40zw3vzc47gi">
          {testimonials.map(t => <figure key={t.name} className="flex flex-col rounded-3xl border border-line bg-white p-6" data-id="element-259" data-mp="92p5762zyb1y">
              <div className="flex gap-0.5 text-gold" aria-label="5 out of 5 stars" data-id="element-260" data-mp="dywf19yik6p6">
                {Array.from({
              length: 5
            }).map((_, i) => <StarIcon key={i} className="h-5 w-5 fill-current" aria-hidden="true" data-id="element-261" data-mp="2fru3yup66f4u" data-mpi={i} />)}
              </div>
              <blockquote className="mt-4 flex-1 text-[16px] leading-relaxed text-ink" data-id="element-262" data-mp="1slazblveovap">“{t.quote}”</blockquote>
              <figcaption className="mt-6 flex items-center gap-3 border-t border-line pt-5" data-id="element-263" data-mp="1ns9ekx8iq1j7">
                <img src={t.photo} alt={t.name} className="h-14 w-14 shrink-0 rounded-full object-cover" loading="lazy" data-id="element-264" data-mp="1iv98wnfkz0sm" />
                <div data-id="element-265" data-mp="1er1miwwlhwxk">
                  <p className="font-bold text-ink" data-id="element-266" data-mp="2bj55ls55gspe">{t.name}</p>
                  <p className="text-sm text-muted" data-id="element-267" data-mp="2bilw8ztkfcmz">{t.role}</p>
                </div>
              </figcaption>
            </figure>)}
        </div>

        <div className="mt-10" data-id="element-268" data-mp="22hxi85469ca3">
          <CtaButton label="I want these results too" caption="Join therapists who organized their workflow" data-id="element-269" data-mp="22h5pd21ylsni" />
        </div>
      </div>
    </section>;
}